import React, { useState, useRef } from "react";
import Barcode from "react-barcode";
import { StringIsNullOrEmpty } from "../../appRedux/actions";

const BarCodePreview = ({ labelContentVisible, productObj, designObj }) => {
  const visibleData = labelContentVisible;
  let isBarCodeVisible = false;
  let isSKUCodeVisible = false;
  let isNameVisible = false;
  let isRetailPriceVisible = false;
  let isBatchNoVisible = false;
  visibleData &&
    visibleData.map((x) => {
      if (x === "1") {
        isBarCodeVisible = true;
      }
      if (x === "2") {
        isSKUCodeVisible = true;
      }
      if (x === "3") {
        isNameVisible = true;
      }
      if (x === "4") {
        isRetailPriceVisible = true;
      }
      if(x === "5"){
        isBatchNoVisible = true;
      }
    });
  return (
    <>
      <div className="dk-sku-barcode">
        {isBarCodeVisible && !StringIsNullOrEmpty(productObj.SKUCode) ? (
          <Barcode
            value={productObj.SKUCode}
            width={designObj.barcodeWidth}
            height={designObj.barcodeHeight}
            textAlign={"center"}
            fontSize={15}
            displayValue={false}
            marginBottom={0}
          />
        ) : (
          ""
        )}
        <div className="dk-label-preview-main">
          {isSKUCodeVisible ? (
            <p className="custom-mg-bt-0">{productObj.SKUCode}</p>
          ) : (
            ""
          )}
          {isRetailPriceVisible ? (
            <div className="dk-label-preview-price">
              {" "}
              {productObj.RetailPrice}
            </div>
          ) : (
            ""
          )}

          {isNameVisible ? (
            <div className="dk-label-preview-name">
              {productObj.ProductName}
            </div>
          ) : (
            ""
          )}
           {isBatchNoVisible ? (
            <div className="dk-label-preview-name">
              {productObj.batchNo}
            </div>
          ) : (
            ""
          )}
          
        </div>
      </div>
    </>
  );
};

export default BarCodePreview;
